import { useCallback, useRef } from 'react';
import type { ThreeColGoodsListItem } from '../types';
import type { FlatListProps } from 'react-native';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';

export const useLogDisplayGoods = (screen?: string, logDisabled?: boolean) => {
  const goodsItemLoggedList = useRef<Array<number>>([]);

  const logAnalyticsEvent = useLogAnalyticsEvent();

  const logDisplayGoods = useCallback<
    NonNullable<FlatListProps<ThreeColGoodsListItem>['onViewableItemsChanged']>
  >(
    ({ viewableItems }) => {
      if (logDisabled) return;

      viewableItems.forEach(({ index, isViewable, item }) => {
        if (index === null || !isViewable) {
          return;
        }

        if (item.type === 'placeholder') {
          return;
        }
        if (goodsItemLoggedList.current.includes(item.data.sno)) {
          return;
        }
        goodsItemLoggedList.current.push(item.data.sno);

        const { data } = item;

        logAnalyticsEvent({
          name: 'DISPLAY_GOODS',
          analytics: {
            ...(isNotNil(screen) && { SCREEN: screen }),
            ad: item.data.item.ad,
            ...data.logging.analytics,
          },
          ably_only_log: data.logging.ably_only_log,
        });

        if (isNotNil(item.data.item.ad)) {
          bridge.logAdEvent({
            action: AdAction.DISPLAY,
            ad: item.data.item.ad,
          });
        }
      });
    },
    [logAnalyticsEvent, screen, logDisabled],
  );

  return { logDisplayGoods };
};
